import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { contact, offices } from '../data/site';
export function FinalCta() {
  return <section id="contact" className="bg-paper py-24" data-id="element-113" data-mp="vgqxol99r6hi">
      <div className="mx-auto grid max-w-[1240px] gap-14 px-6 lg:grid-cols-2 lg:items-center" data-id="element-114" data-mp="19epctsvez6y2">
        <div data-id="element-115" data-mp="15dlvf1xpx2uq">
          <p className="eyebrow text-green-dark" data-id="element-116" data-mp="15cu80ee9ybfj">Get In Touch</p>
          <h2 className="mt-5 font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[44px]" data-id="element-117" data-mp="15fq7461uz65k">
            Ready to talk financial strategy?
          </h2>
          <div className="double-rule mt-7 w-24 text-ink" aria-hidden="true" data-id="element-118" data-mp="1ebxt1nx050wo" />
          <p className="mt-6 max-w-lg text-[16px] leading-relaxed text-ink-70" data-id="element-119" data-mp="1t2ewfct760w7">
            Book a consultation with a partner. We will review where you stand on
            tax, audit and reporting, and set out what needs doing — before any work
            is committed.
          </p>
          <a href={`tel:${contact.phonePrimary.replace(/\s/g, '')}`} className="mt-9 inline-flex items-center gap-3 bg-green px-7 py-4 font-mono text-[11px] uppercase tracking-[0.1em] text-ink transition-colors hover:bg-green-dark hover:text-white" data-id="element-120" data-mp="1x5uorwy8hf33">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-121" data-mp="x3io1cuo7x8y" />
            Call {contact.phonePrimary}
          </a>
        </div>

        <ul className="space-y-4" data-id="element-122" data-mp="1246h042gmo5t">
          {offices.map(office => <li key={office.label} className="border border-line bg-white p-6" data-id="element-123" data-mp="163fcbdd5eu3h">
              <p className="font-mono text-[10px] uppercase tracking-[0.12em] text-green-dark" data-id="element-124" data-mp="1b31pjmsz8aca">
                {office.label}
              </p>
              <p className="mt-3 text-[14px] leading-relaxed text-ink" data-id="element-125" data-mp="1fv1rfkslxdbi">{office.address}</p>
              <p className="mt-1 font-mono text-[11px] text-ink-50" data-id="element-126" data-mp="1kstm2mkmzdje">{office.box}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}